import { render, staticRenderFns } from "./InputSconto.vue?vue&type=template&id=a267ccf2&scoped=true&"
import script from "./InputSconto.vue?vue&type=script&lang=js&"
export * from "./InputSconto.vue?vue&type=script&lang=js&"
import style0 from "./InputSconto.vue?vue&type=style&index=0&id=a267ccf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a267ccf2",
  null
  
)

export default component.exports